
import React from "react";

const EftposTransaction = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_491_2889)">
<path d="M11.6853 3.303C8.98119 4.54269 7.14765 6.91958 7.14765 9.643C7.14765 13.0839 10.3041 15.8707 14.1997 15.8707C15.9895 15.8707 17.2443 15.4559 18.7131 14.5676C18.8687 14.4749 19.0438 14.4017 19.1605 14.5481C19.2286 14.6311 19.1994 14.7336 19.1508 14.8263C17.5458 17.784 14.2775 19.8387 10.6105 19.8387C5.19252 19.8387 0.800781 15.4315 0.800781 9.99441C0.800781 6.8903 2.23065 4.12295 4.46786 2.3171C6.1555 0.970032 10.3673 0.784566 11.6853 3.303Z" fill="url(#paint0_linear_491_2889)"/>
<path d="M19.0379 7.11513C19.0379 10.3852 15.9252 13.0354 12.0879 13.0354C11.5286 13.0354 10.0161 12.9573 8.93639 12.4546C8.62999 12.3082 8.65917 12.1325 8.87317 12.0397C9.36438 11.8347 13.2211 11.0929 13.2211 7.11513C13.2211 3.13737 9.12607 0.228486 4.47656 2.32718C6.15447 0.970349 8.28955 0.160156 10.6143 0.160156C15.1665 0.160156 19.0379 3.27403 19.0379 7.11513Z" fill="#E50056"/>
</g>
<defs>
<linearGradient id="paint0_linear_491_2889" x1="10.0905" y1="13.247" x2="6.31163" y2="-6.12533" gradientUnits="userSpaceOnUse">
<stop offset="0.1411" stopColor="#E50056"/>
<stop offset="0.75" stopColor="#1F0038"/>
</linearGradient>
<clipPath id="clip0_491_2889">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
);

export default EftposTransaction;